document.addEventListener("DOMContentLoaded", function () {
  const urlParams = new URLSearchParams(window.location.search);
  const formSuccess = urlParams.get('customer_posted') === 'true' || 
                      urlParams.get('contact_posted') === 'true';
  
  if (formSuccess) {
    const successMessage = document.getElementById('contact-success-message');
    if (successMessage) {
      successMessage.style.display = 'flex';

      const cleanUrl = window.location.pathname + window.location.hash;
      window.history.replaceState({}, document.title, cleanUrl);

      // Close modal functions
      const closeModal = () => {
        successMessage.style.display = 'none';
      };

      // Close button
      const closeButton = document.getElementById('contact-modal-close');
      if (closeButton) {
        closeButton.addEventListener('click', closeModal);
      }

      // Click overlay to close
      successMessage.addEventListener('click', (e) => {
        if (e.target === successMessage) {
          closeModal();
        }
      });

      // ESC key to close
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && successMessage.style.display === 'flex') {
          closeModal();
        }
      });
    }
  }

  const customSelects = document.querySelectorAll(".custom-select");

  customSelects.forEach(function (customSelect) {
    const trigger = customSelect.querySelector(".custom-select-trigger");
    const optionElements = customSelect.querySelectorAll(
      ".custom-select-option",
    );
    const placeholder = customSelect.querySelector(
      ".custom-select-placeholder",
    );
    const hiddenInput = customSelect.parentElement.querySelector(
      'input[type="hidden"]',
    );

    trigger.addEventListener("click", function (e) {
      e.stopPropagation();

      document
        .querySelectorAll(".custom-select.open")
        .forEach(function (otherSelect) {
          if (otherSelect !== customSelect) {
            otherSelect.classList.remove("open");
          }
        });

      customSelect.classList.toggle("open");
    });

    optionElements.forEach(function (option) {
      option.addEventListener("click", function (e) {
        e.stopPropagation();

        const value = this.getAttribute("data-value");
        const text = this.textContent;

        if (hiddenInput) {
          hiddenInput.value = value;
        }

        placeholder.textContent = text;
        trigger.classList.add("has-value");

        optionElements.forEach(function (opt) {
          opt.classList.remove("selected");
        });
        this.classList.add("selected");

        customSelect.classList.remove("open");
      });
    });
  });

  document.addEventListener("click", function (e) {
    if (!e.target.closest(".custom-select")) {
      document
        .querySelectorAll(".custom-select.open")
        .forEach(function (select) {
          select.classList.remove("open");
        });
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      document
        .querySelectorAll(".custom-select.open")
        .forEach(function (select) {
          select.classList.remove("open");
        });
    }
  });

  const emailInput = document.getElementById("ContactForm-email");
  const phoneInput = document.getElementById("ContactForm-phone");
  const privacyCheckbox = document.getElementById("privacy-agree");
  const submitButton = document.getElementById("contact-submit");
  const emailError = document.getElementById("email-error");
  const phoneError = document.getElementById("phone-error");

  // Email validation
  function validateEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  // Phone validation
  function validatePhone(phone) {
    // Allow formats: 090-0000-0000, 09000000000, 03-0000-0000, etc.
    const phoneRegex = /^0\d{1,4}-?\d{1,4}-?\d{4}$/;
    return phoneRegex.test(phone);
  }

  function checkFormValidity() {
    if (!emailInput || !phoneInput || !privacyCheckbox) {
      return;
    }

    const isEmailValid = emailInput.value && validateEmail(emailInput.value);
    const isPhoneValid = phoneInput.value && validatePhone(phoneInput.value);
    const isPrivacyChecked = privacyCheckbox.checked;

    if (submitButton) {
      submitButton.disabled = !(
        isEmailValid &&
        isPhoneValid &&
        isPrivacyChecked
      );
    }
  }

  if (emailInput) {
    emailInput.addEventListener("blur", function () {
      if (this.value && !validateEmail(this.value)) {
        this.classList.add("form-input--error");
        emailError.textContent = "正しいメールアドレスを入力してください";
      } else {
        this.classList.remove("form-input--error");
        emailError.textContent = "";
      }
      checkFormValidity();
    });

    emailInput.addEventListener("input", function () {
      if (
        this.classList.contains("form-input--error") &&
        validateEmail(this.value)
      ) {
        this.classList.remove("form-input--error");
        emailError.textContent = "";
      }
      checkFormValidity();
    });
  }

  if (phoneInput) {
    phoneInput.addEventListener("blur", function () {
      if (this.value && !validatePhone(this.value)) {
        this.classList.add("form-input--error");
        phoneError.textContent =
          "正しい電話番号を入力してください（例：090-0000-0000）";
      } else {
        this.classList.remove("form-input--error");
        phoneError.textContent = "";
      }
      checkFormValidity();
    });

    phoneInput.addEventListener("input", function () {
      if (
        this.classList.contains("form-input--error") &&
        validatePhone(this.value)
      ) {
        this.classList.remove("form-input--error");
        phoneError.textContent = "";
      }
      checkFormValidity();
    });
  }

  if (privacyCheckbox) {
    privacyCheckbox.addEventListener("change", function () {
      checkFormValidity();
    });
  }

  checkFormValidity();

  const contactForm = document.querySelector('form[action*="contact"]');
  if (contactForm) {
    contactForm.addEventListener("submit", function (e) {
      const categoryInput = document.getElementById("ContactForm-category");

      if (categoryInput && !categoryInput.value) {
        e.preventDefault();
        alert("お問い合わせの種類を選択してください");
        return false;
      }

      if (emailInput && !validateEmail(emailInput.value)) {
        e.preventDefault();
        emailInput.classList.add("form-input--error");
        emailError.textContent = "正しいメールアドレスを入力してください";
        emailInput.focus();
        return false;
      }

      if (phoneInput && !validatePhone(phoneInput.value)) {
        e.preventDefault();
        phoneInput.classList.add("form-input--error");
        phoneError.textContent =
          "正しい電話番号を入力してください（例：090-0000-0000）";
        phoneInput.focus();
        return false;
      }

      if (privacyCheckbox && !privacyCheckbox.checked) {
        e.preventDefault();
        alert("プライバシーポリシーに同意してください");
        return false;
      }

      return true;
    });
  }
});
